import Utility from "../../../shared/utility";
import AddFavourite from "../../utility/js/addFav";
import EncryptUtility from "../../utility/js/encrypt-utility";
import breadcrumbComp from "../../common/breadcrumb-comp";
import Chart from "chart.js/auto";
import moment from "moment";
import commonService from "../../common/js/common-api-service";
export default {
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      refresh: true,
      subPage: "",
      backSlash: "",
      showAdd: false,
      pageUrl: "",
      selectedReportDays: 5,
      targetDays: 5,
      dockToStockData: [],
      chartInstance: null,
      ctxChart: null,
      totalRecords: 0,
      exportDisable: true,
      showDockToStockData: true,
      maxStartDate: new Date().toISOString().split("T")[0],
      minEndDate: new Date(new Date().getTime() - 86400000).toISOString().split("T")[0],
      maxEndDate: new Date(new Date().getTime()).toISOString().split("T")[0],
      sDate: "",
      eDate: "",
      showStartDate: true,
      showEndDate: true,
      startDate: false,
      endDate: false,
      selectedProject: [],
      projectList: [],
      selectedBusiness: [],
      businessList: [],
      disableProject: false,
      disableBusiness: true,
      showData: false,
      reportDaysList: [
        {
          text: "5 Days",
          value: 5,
        },
        {
          text: "10 Days",
          value: 10,
        },
        {
          text: "15 Days",
          value: 15,
        },
        {
          text: "30 Days",
          value: 30,
        },
        {
          text: "60 Days",
          value: 60,
        },
        {
          text: "90 Days",
          value: 90,
        },
      ],
      dockToStockHeaders: [
        {
          text: "Day",
          align: "start",
          value: "Day",
          class: "primary customwhite--text",
        },
        {
          text: "Date",
          value: "Date",
          class: "primary customwhite--text",
        },
        {
          text: "Dock Inbound",
          value: "DockInbound",
          class: "primary customwhite--text",
        },
        {
          text: "Dock Pending",
          value: "DockPending",
          class: "primary customwhite--text",
        },
        {
          text: "Average Dock To Stock",
          value: "AvgDock2Stock",
          class: "primary customwhite--text",
        },
        {
          text: "Average Day",
          value: "AvgDay",
          class: "primary customwhite--text",
        },
        {
          text: "Target",
          value: "Target",
          class: "primary customwhite--text",
        },
      ],
      json_fields: {
        Day: "Day",
        Date: "Date",
        "Dock Inbound": "DockInbound",
        "Dock Pending": "DockPending",
        "Average Dock To Stock": "AvgDock2Stock",
        "Average Day": "AvgDay",
        Target: "Target",
      },
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    let projectData = await commonService.getProject("get", this.userId);
    this.projectList = projectData.ProjectInfo;
    this.projectList.unshift(JSON.parse('{"ProjKey":0, "Project":"ALL"}'));
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.sDate ? moment(this.sDate).format("MM/DD/YYYY") : "";
    },
    computedEndDateFormattedMomentjs() {
      return this.eDate ? moment(this.eDate).format("MM/DD/YYYY") : "";
    },
  },
  methods: {
    //Reset the screen
    resetFunction() {
      this.showStartDate = false;
      this.showEndDate = false;
      this.$nextTick(() => {
        this.showStartDate = true;
        this.sDate = null;
        this.showEndDate = true;
        this.eDate = null;
      });
      this.selectedReportDays = 5;
      this.targetDays = 5;
      this.dockToStockData = [];
      this.totalRecords = 0;
      this.exportDisable = true;
      this.showDockToStockData = true;
      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }
      this.ctxChart = null;
      this.$nextTick(() => {
        this.onClickSearch();
      });
      this.selectedProject = [];
      this.selectedBusiness = [];
      this.businessList = [];
      this.disableProject = false;
      this.disableBusiness = true;
      this.showData = false;
    },
    // set end Date
    setEndDate() {
      if (!this.sDate) return;
      let minEndDate = new Date(this.sDate);
      this.minEndDate = new Date(minEndDate.getTime() + 0).toISOString().substr(0, 10);
      let maxSDate = new Date(this.maxStartDate);
      this.maxEndDate = new Date(maxSDate.getTime() + 0).toISOString().substr(0, 10);
      this.selectedReportDays = null;
    },
    //Change in Report Days
    changeReportDays() {
      this.targetDays = 5;
      this.sDate = null;
      this.eDate = null;
    },
    //Get Dock To Stock Report
    onClickSearch() {
      let isReportDaysMode = this.selectedReportDays && this.selectedReportDays > 0;
      let isDateMode = this.sDate;
      if (!isReportDaysMode && !isDateMode) {
        let Alert = {
          type: "error",
          isShow: true,
          message: "Please select either Report Days or Start Date",
        };
        this.$store.commit("ConfigModule/Alert", Alert);
        return;
      }
      if (isReportDaysMode) {
        if (parseInt(this.targetDays) > parseInt(this.selectedReportDays) || parseInt(this.targetDays) === 0 || parseInt(this.targetDays) === 1) {
          let Alert = {
            type: "error",
            isShow: true,
            message: "Target Days should be equal to or less than the Report Days selected and Target Days should be greater than 1",
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          return;
        }
      }
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      let projId = this.selectedProject.includes(0) ? 'ALL' : this.selectedProject.join(',');
      let buId = this.selectedBusiness.includes(0) ? 'ALL' : this.selectedBusiness.join(',');
      let obj = {
        FromDate: isDateMode ? Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00") : null,
        ToDate: isDateMode ? Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59") : null,
        Days: isReportDaysMode ? this.selectedReportDays : 0,
        proj_id: projId,
        bu_id: buId,
        Target: parseInt(this.targetDays),
      };
      this.axios
        .post("/cr/dock_to_stock_report", obj)
        .then((response) => {
          if (response.status == 200 || response.status == 204) {
            let data = response.data.body;
            const newArr = data.map((obj) => {
              return {
                ...obj,
                RawDate: obj?.Date,
                Date: Utility.displayDateFormat(obj?.Date),
              };
            });
            this.dockToStockData = newArr;
            this.totalRecords = newArr.length;
            this.exportDisable = false;
            this.showDockToStockData = false;
            this.$nextTick(() => {
              this.showDockToStockData = true;
            });
            this.showData = true;
            this.prepareChart();
          } else {
            this.dockToStockData = [];
            this.totalRecords = 0;
            this.exportDisable = true;
            this.showData = false;
            let Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          this.dockToStockData = [];
          this.totalRecords = 0;
          this.exportDisable = true;
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          let Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    prepareChart() {
      const sorted = [...this.dockToStockData].sort((a, b) => new Date(a.RawDate) - new Date(b.RawDate));
      const labels = sorted.map((d) => {
        const date = new Date(d.RawDate);
        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
      });
      const newData = {
        labels,
        datasets: [
          {
            type: "bar",
            label: "Dock Inbound",
            data: sorted.map((d) => d.DockInbound || 0),
            backgroundColor: "#005ba8",
            yAxisID: "y",
            borderRadius: 4,
            maxBarThickness: 15,
          },
          {
            type: "line",
            label: "Average Dock To Stock",
            data: sorted.map((d) => d.AvgDock2Stock || 0),
            borderColor: "#007bff",
            tension: 0.3,
            yAxisID: "y1",
          },
          {
            type: "line",
            label: "Average Day",
            data: sorted.map((d) => d.AvgDay || 0),
            borderColor: "red",
            tension: 0.3,
            yAxisID: "y1",
          },
          {
            type: "line",
            label: "Target",
            data: sorted.map((d) => d.Target || 0),
            borderColor: "green",
            tension: 0,
            pointRadius: 0,
            yAxisID: "y1",
          },
        ],
      };
      const newOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              usePointStyle: true,
              generateLabels: (chart) => {
                const datasets = chart.data.datasets;
                return datasets.map((ds, i) => ({
                  text: ds.label,
                  fillStyle: ds.backgroundColor,
                  strokeStyle: ds.borderColor,
                  lineWidth: ds.borderWidth,
                  hidden: !chart.isDatasetVisible(i),
                  datasetIndex: i,
                  pointStyle: ds.type === "bar" ? "rect" : "line",
                }));
              },
              padding: 20,
              font: {
                size: 12,
                weight: "bold",
              },
            },
          },
          title: {
            display: true,
            text: "Dock to Stock in Days",
          },
        },
        scales: {
          y: { beginAtZero: true, position: "left" },
          y1: {
            beginAtZero: true,
            position: "right",
            grid: { drawOnChartArea: false },
          },
        },
      };
      this.chartDataLine = null;
      this.chartOptionsLine = null;
      this.$nextTick(() => {
        if (this.chartInstance) {
          this.chartInstance.destroy();
        }
        this.ctxChart = document.getElementById("dockChart");
        if (!this.ctxChart) return;
        this.chartInstance = new Chart(this.ctxChart, {
          type: "bar",
          data: newData,
          options: newOptions,
        });
      });
      this.renderChart(newData, newOptions);
    },
    renderChart(data, options) {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }
      this.ctxChart = document.getElementById("dockChart");
      this.chartInstance = new Chart(this.ctxChart, {
        type: "bar",
        data,
        options,
      });
    },
    async exportToExcel() {
      if (this.totalRecords <= 15000) {
        this.startDownload();
        let exportProjId = this.selectedProject.includes(0) ? 'ALL' : this.selectedProject.join(',');
        let exportBuId = this.selectedBusiness.includes(0) ? 'ALL' : this.selectedBusiness.join(',');
        let exportObj = {
          FromDate: this.selectedReportDays ? null : Utility.inputDateFormat(this.computedDateFormattedMomentjs, "00:00:00"),
          ToDate: this.selectedReportDays ? null : Utility.inputDateFormat(this.computedEndDateFormattedMomentjs, "23:59:59"),
          Days: this.selectedReportDays ? this.selectedReportDays : 0,
          proj_id: exportProjId,
          bu_id: exportBuId,
          Target: parseInt(this.targetDays),
        };
        const response = await this.axios.post("cr/dock_to_stock_report", exportObj);
        let responseData = response.data.body;
        const formattedData = responseData.map((obj) => ({
          ...obj,
          Date: Utility.displayDateFormat(obj?.Date),
        }));
        Utility.exportExcel(formattedData, this.json_fields, Utility.excelNewFileName("Dock_To_Stock_Report"), "Dock To Stock Report");
        this.finishDownload();
      } else {
        this.finishDownload();
        return true;
      }
    },
    //Get Business List
    onProjectSelect(selProject) {
      this.businessList = [];
      this.selectedBusiness = [];
      if (!selProject || selProject.length === 0) {
        this.disableBusiness = true;
        return;
      }
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(`/cp/business_header?Pass=2&UserId=${this.userId}`)
        .then((response) => {
          if (response.status == 200) {
            let responseData = JSON.parse(response.data.body.message);
            if (selProject.includes(0)) {
              this.businessList = responseData;
            } else {
              this.businessList = responseData.filter((obj) => selProject.includes(obj.ProjKey));
            }
            this.businessList.unshift(JSON.parse('{"BuKey":0, "Business":"ALL"}'));
            this.disableBusiness = false;
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
    //Start the Loader when excel process starts
    startDownload() {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    // end the Loader when the process is completed
    finishDownload() {
      let LoaderDialog = {
        visible: false,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
    },
    //To check whether input value is number or not
    isNumber(event) {
      let value = Utility.isNumber(event);
      return value;
    },
    // To check if the user has access access to that action or not
    actionSetter(action) {
      if (this.actionList !== null && this.actionList.length > 0) {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter.length == 1 ? true : false;
      } else return false;
    },
    //On Click of Favorite icon
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
  },
  components: {
    breadcrumbComp,
  },
};
